// src/Component/former/Former.js
import React from 'react';
import { Helmet } from 'react-helmet'; // Import Helmet for SEO
import './vat.css'; // Import the CSS for styling
import extra1 from '../../image/extra1.png';
import extra2 from '../../image/extra2.png';

const Vat = () => {
  return (
    <div className="details-container">

      {/* SEO Meta Tags */}
      <Helmet>
        <title>Extractor Press for Paper Mill Machine Manufacturers in Gujarat, India</title>
        <meta
          name="description"
          content="Extractor Press for Paper Mill Machine Manufacturers in Gujarat, India. P. Rakesh Industries is a leading manufacturer of high-pressure and wet extractor press machines for paper mills in India. Offering top loading and bottom loading designs, our hydro extractor presses ensure excellent ply bonding, low energy consumption, and improved sheet dryness for enhanced productivity."
        />
        <meta property="og:title" content="Extractor Press for Paper Mill Machine Manufacturers in Gujarat, India" />
        <meta
          property="og:description"
          content="Extractor Press for Paper Mill Machine Manufacturers in Gujarat, India. P. Rakesh Industries is a leading manufacturer of high-pressure and wet extractor press machines for paper mills in India. Offering top loading and bottom loading designs, our hydro extractor presses ensure excellent ply bonding, low energy consumption, and improved sheet dryness for enhanced productivity."
        />
        <meta property="og:url" content="https://pripapermachines.com/extractor-press-for-paper-mill-machine-manufacturers-in-gujarat-india" />
        <link rel="canonical" href="https://pripapermachines.com/extractor-press-for-paper-mill-machine-manufacturers-in-gujarat-india" />
      </Helmet>

      <div className="details-content">
        {/* Left Column */}
        <div className="column left">
          <h1 style={{color:"#4d7544"}} className='mobileresponsiveview'>EXTRACTOR PRESS</h1>
          <div className="left-content">
            <p style={{
              backgroundColor:" #4d7544",borderRadius:"10px",
              color:"white",padding:"20px", textAlign:"left"
            }}>
              <b style={{fontSize:"20px"}}> P. Rakesh Industries Offers two different designs of Extractor press:</b>
              <br /><br />
              Top loading extractor roll  <br />
              Bottom loading extractor roll
              <br /><br />
              The extractor press is a low-energy-cost technique for extracting water from the board without any impact on the quality of the product. This economical technique uses the roll-nip method to achieve water removal. This can be installed with either one or two rolls. An arrangement of top loading or bottom loading can be used.
              <br /><br />
              <div className="image-container">
                <img src={extra2} alt="Extractor Press for Paper Mill" className="responsive-image" />
                <div className="overlay-text">Bottom Loading</div>
              </div>
            </p>
          </div>
        </div>

        {/* Right Column */}
        <div className="column right" style={{marginLeft:"30px",marginTop:"15px"}}>
          <div className="column-right">
            <h1 style={{color:"#4d7544", marginTop:"-10px",textAlign:"left",fontSize:"40px"}} className='desktopresponsiveview'>EXTRACTOR PRESS</h1>

            <h1 style={{color:"#4d7544",textAlign:"left",fontSize:"26px"}}>Key Features:</h1>
            <ul style={{color:"black",textAlign:"left"}}>
              <li>Excellent ply bonding, avoid blowing problems.</li>
              <br />
              <li>Sheet dryness can be improved with low energy consumption.</li>
              <br />
              <li>Less moisture content before press, can apply more load at the first press.</li>
              <br />
              <li>Farming can be supplied either with stainless steel cladding, complete stainless steel, or mild steel with epoxy paint on request.</li>
              <br />
              <li>Improves productivity.</li>
            </ul>

            <div className="image-container">
              <img src={extra1} alt="Extractor Press for Paper Mill" className="responsive-image" />
              <div className="overlay-text" style={{color:"#4d7544"}}>Top Loading</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Vat;
